<template>
  <div class="admin-tenant-normalized-names">
    <div class="__header-container">
      <p class="__header">
        {{ $t('page.admin-tenant.normalized-names.title') }}
      </p>
      <BaseButton isSmall isSquare isGrey class="__add-button" @click.native="openAddDialog">
        {{ $t('actions.add') }} <BaseIcon name="plus" />
      </BaseButton>
    </div>
    <p class="__description">
      {{ $t('page.admin-tenant.normalized-names.description') }}
    </p>
    <NormalizedNamesList @on-edit="openEditDialog" @on-delete="openDeleteDialog" />
    <AddNormalizedNameDialog ref="addNormalizedNameDialog" @action-succeeded="onRefresh" />
    <EditNormalizedNameDialog ref="editNormalizedNameDialog" />
    <DeleteNormalizedNameDialog ref="deleteNormalizedNameDialog" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import NormalizedNamesList from '@/components/page-admin-tenants/NormalizedNamesList.vue';
import AddNormalizedNameDialog from '@/components/page-admin-tenants/AddNormalizedNameDialog.vue';
import EditNormalizedNameDialog from '@/components/page-admin-tenants/EditNormalizedNameDialog.vue';
import DeleteNormalizedNameDialog from '@/components/page-admin-tenants/DeleteNormalizedNameDialog.vue';

export default {
  name: 'admin-tenant-normalized-names',
  components: {
    BaseButton,
    BaseIcon,
    NormalizedNamesList,
    AddNormalizedNameDialog,
    EditNormalizedNameDialog,
    DeleteNormalizedNameDialog,
  },
  computed: {
    ...mapGetters('tenant', ['tenant']),
  },
  methods: {
    ...mapActions('tenant', ['getNormalizedNames']),
    openAddDialog() {
      this.$refs.addNormalizedNameDialog.open();
    },
    openEditDialog(normalizedName) {
      this.$refs.editNormalizedNameDialog.open(normalizedName);
    },
    openDeleteDialog(normalizedName) {
      this.$refs.deleteNormalizedNameDialog.open(normalizedName);
    },
    onRefresh() {
      this.getNormalizedNames();
    },
  },
  watch: {},
  created() {
    this.getNormalizedNames();
  },
};
</script>

<style lang="scss">
.admin-tenant-normalized-names {
  > .__header-container {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .__header {
      flex-grow: 1;
      font-weight: bold;
      display: flex;
      gap: 8px;
      align-items: center;
    }
    .base-icon {
      width: 14px;
      margin-left: 4px;
    }
  }

  > .__description {
    margin-bottom: 12px;
    line-height: 1.5;
  }
  > .__action-bar {
    display: flex;
    margin: 16px 0;
    justify-content: flex-end;
  }

  > .__content {
    background: $color-white;
    border-radius: $border-radius-root;

    .__header {
      display: flex;
      justify-content: flex-end;
      margin: 16px 0;
    }
  }
}
</style>
